exports = module.exports = require("./../node_modules/.npminstall/css-loader/0.21.0/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-tabs[_v-15ba69ca] {\n  margin-bottom: 15px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/css-loader/0.21.0/css-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-15ba69ca&file=TabGroup.vue&scoped=true!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./src/TabGroup.vue
// module id = 328
// module chunks = 0